import clsx from 'clsx';
// import NextImage from 'next/image';
// TODO: fix layout issue and replace image instead of legace image
import NextImage from 'next/legacy/image';
import { ImageProps } from './types';

const Image = (props: ImageProps) => (
  <NextImage
    className={clsx({ grayscale: props.darkWhite }, props.className)}
    {...props}
    loader={({ src, width }: any) => `${src}?w=${width}`}
  />
);

export default Image;
